import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'usb-rent-a-car-filter',
  templateUrl: './rent-a-car-filter.component.html',
  styleUrls: ['./rent-a-car-filter.component.scss']
})
export class RentACarFilterComponent implements OnInit {

  @Input() arrayFilterAcriss: any[] = []
  @Input() currencyAgency: any;
  @Input() currencies: any;
  @Output() selectedAcrissKeyEmit = new EventEmitter<any>();

  public selectedAcrissKey

  constructor() { }

  ngOnInit(): void {
  }

  selectFilterAcriss(event:any, type:any): void{

  if(this.selectedAcrissKey == type){
    this.selectedAcrissKey = null;
    const data = {
      event: null,
      type: 'clearFilter'
    };
    // this.CategoryResultComponent.clearFilter();
    this.selectedAcrissKeyEmit.emit(data);
    return
  }

  this.selectedAcrissKey = type;

    const data = {
      event: event.target.checked,
      type: type
    };

    this.selectedAcrissKeyEmit.emit(data);
  }

}
